import { BulkSmsLayout } from '@features/BulkSms'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const Route = createFileRoute('/bulk-sms/')({
  component: BulkSmsLayout,
  staticData: {
    breadcrumb: t('bulksms.title'),
  },
})
